var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-section"},[_c('HeroSection',{attrs:{"workers":_vm.workers},on:{"scroll-to-packages":_vm.handleScrollToPackages}}),_c('PackagesSection',{ref:"packagesSection",attrs:{"packages":_vm.packages}}),_c('ServicesSection',{attrs:{"services":_vm.services}}),_c('OurServicesSection'),_c('AboutIt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }